import React, { Component } from "react";
import moment from "moment";
import qs from "qs";
import { InputGroup, FormControl } from "react-bootstrap";
import ReportsApi from "../../../pages/client-admin/reports/ReportsApi";
import { HeaderTextWithActions } from "../../../components/Base";
import ReportsTable from "../../../components/ReportsTable";
import GroupDropdown from "../../../components/dashboard/GroupDropdown";
import DateRangeDropdown from "../../../components/dashboard/DateRangeDropdown";
import core from "../../../vendors/core-api";
import { useParams, Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import TitleHelmet from "../../../partials/TitleHelmet";
import { useSelector } from "react-redux";
import { DB_DATE_FORMAT } from "../../../constants";
import { capitalizeText } from "../../../../app/helpers";
import Breadcrumbs from "../../../components/Breadcrumbs";
import ExportCSV from "../../../components/ExportCSV";
import PaginationBar from "../../../components/PaginationBar";
import PacmanWrapper from "../../../components/dashboard/PacmanWrapper";

export default function Page(props) {
  const { mode = "" } = useParams(),
    { user } = useSelector((state) => state.auth);
  const {
    filter = "",
    duration = "day",
    attr = "",
    view = "",
    date = moment().format(DB_DATE_FORMAT),
    endDate = "",
    page = 1,
    limit = 30,
  } = qs.parse(props.location.search, { ignoreQueryPrefix: true });

  return (
    <MainComponent
      id={user.client_id}
      view={view}
      attr={attr}
      user={user}
      filter={filter}
      duration={duration}
      date={date}
      endDate={endDate}
      showEndDatePicker={duration === "between"}
      webview={mode === "webview"}
      page={page}
      limit={limit}
    />
  );
}

class MainComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSplashScreen: true,
      redirectTo: "",
      brand_name: "Brands",
    };

    this.api = core("pu").get();

    this.getLoggedInUser = this.getLoggedInUser.bind(this);
  }

  getLoggedInUser = (field = "fullname") => {
    const { user = {} } = this.props;
    if (field === "fullname") {
      return user.first_name + " " + user.last_name;
    } else {
      return user[field];
    }
  };

  render() {
    const actions = {
      getLoggedInUser: this.getLoggedInUser,
      setBrandName: (brand_name = "") => {
        this.setState({ brand_name });
      },
      setSplashScreen: (showSplashScreen = true) => {
        this.setState({ showSplashScreen });
      },
      setRedirectTo: (redirectTo = "") => {
        this.setState({ redirectTo });
      },
    };

    const {
      id = "",
      view = "",
      attr = "",
      filter = "",
      page = 1,
      limit = 30,
      webview = "",
      user = {},
      user: { brands = [], stores = [], iam_role = "" },
      duration = "day",
      date = moment().format(DB_DATE_FORMAT),
      endDate = "",
      showEndDatePicker = false,
    } = this.props;

    return (
      <>
        <TitleHelmet title={this.state.brand_name} />

        {this.state.redirectTo !== "" ? (
          <Redirect to={this.state.redirectTo} />
        ) : (
          <></>
        )}

        <GroupComponent
          webview={webview}
          id={id}
          api={this.api}
          actions={actions}
          filter={filter}
          duration={duration}
          view={view}
          attr={attr}
          user={user}
          date={date}
          endDate={endDate}
          showEndDatePicker={showEndDatePicker}
          brands={brands}
          stores={stores}
          role={iam_role}
          page={page}
          limit={limit}
        />
      </>
    );
  }
}

class GroupComponent extends ReportsApi {
  render() {
    const { role = "" } = this.props;
    const {
        data_status = "",
        data = {},
        selectedBrand = { id: "", name: "All" },
        duration = this.props.duration || "day",
        date = this.props.date || moment().format(DB_DATE_FORMAT),
        page = 1,
        limit = 30,
        isCustomDate = this.props.isCustomDate || false,
        showEndDatePicker = this.props.showEndDatePicker ||
          duration === "between",
        endDate = this.props.endDate ||
          this.props.date ||
          moment().format(DB_DATE_FORMAT),
      } = this.state,
      isLoading = data_status !== "fetched";

    const title = capitalizeText(this.props.filter) || "Orders";
    const { headers = [], orders = [], totalResults = 0 } = data;

    const pagesArr = [];
    for (let i = 0; i * limit < totalResults; i++) {
      pagesArr.push(i);
    }

    return (
      <>
        <TitleHelmet title="Reports" />
        {this.props.webview && (
          <div className="row">
            <div className="col-md-9 col-sm-12">
              <Breadcrumbs>
                <Breadcrumbs.Item
                  text="Dashboard"
                  link={`/webview/dashboard`}
                  active="true"
                />
              </Breadcrumbs>
            </div>
          </div>
        )}
        <HeaderTextWithActions className="mb-0 mb-md-4" title={title} />

        <div className="mb-4 position-sticky" style={{ left: 0 }}>
          <InputGroup className="mb-3 overflow-hidden">
            <InputGroup.Prepend>
              <InputGroup.Text id="text-search-input">Search </InputGroup.Text>
            </InputGroup.Prepend>

            <FormControl
              type="text"
              aria-label="Search"
              aria-describedby="inputGroup-sizing-default"
              placeholder="Order#, customer name, email, and contact number"
              value={this.state.search}
              onChange={(e) => this.handleTextSearchInputChange(e)}
              onKeyDown={this.keyPress}
            />

            {this.state.search && (
              <button
                className="btn btn-default border-left-0"
                type="button"
                onClick={this.handleClearSearch}
                title="Clear search"
              >
                <i className="fa fa-times text-muted"></i>
              </button>
            )}

            <button
              className="btn btn-default"
              onClick={this.handleTextSearch}
              disabled={data_status === "fetching"}
              style={{ minWidth: "42px" }}
            >
              {data_status === "fetching" ? (
                <span
                  className="spinner-border spinner-border-sm text-primary"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <i className="fa fa-search"></i>
              )}
            </button>
          </InputGroup>
        </div>

        {isLoading ? (
          <PacmanWrapper removeBackgroundColor />
        ) : (
          <div className="d-flex flex-column">
            <div
              className="d-flex align-items-center justify-content-between mb-4 position-sticky flex-nowrap"
              style={{ left: "0", zIndex: 100 }}
            >
              <div
                className="d-flex align-items-center flex-nowrap"
                style={{ left: "0" }}
                onClick={() => this.handleOnDateInputClick()}
              >
                <form className="d-flex align-items-center flex-nowrap mr-2 mb-0">
                  <div className="input-group flex-nowrap">
                    <span
                      className="input-group-text text-nowrap"
                      id="inputGroup-sizing-sm"
                    >
                      Order Date
                    </span>
                    <input
                      type="date"
                      className="form-control rounded-0 d-inline-block"
                      aria-label="Small"
                      aria-describedby="inputGroup-sizing-sm"
                      onChange={this.handleDateInputChange}
                      value={this.state.date || moment().format(DB_DATE_FORMAT)}
                      style={{ width: 155 }}
                    />
                    {showEndDatePicker && (
                      <div className="d-flex align-items-center flex-nowrap">
                        <div className="d-flex px-2 text-nowrap"> to </div>
                        <input
                          type="date"
                          name="endDate"
                          className="form-control rounded-0 d-inline-block"
                          aria-label="Small"
                          aria-describedby="inputGroup-sizing-sm"
                          onChange={(e) =>
                            this.handleDateInputChange(e, "endDate")
                          }
                          min={this.state.date}
                          value={
                            endDate ||
                            this.state.date ||
                            moment().format(DB_DATE_FORMAT)
                          }
                          style={{ width: 155 }}
                        />
                      </div>
                    )}
                    <button
                      type="button"
                      className="btn btn-primary rounded-0"
                      onClick={this.handleSearchDate}
                    >
                      <i className="fa fa-search p-0" />
                    </button>
                  </div>
                </form>

                <div className="d-flex align-items-center flex-nowrap">
                  <ExportCSV
                    filename={`${title}-${this.handleDropdownText(
                      duration || this.props.duration,
                      date,
                      isCustomDate,
                    )}-${date}.csv`}
                    // headers={csvHeaders}
                    url="/dashboard/reports"
                    reqBody={this.getReqBody()}
                  />
                </div>
              </div>

              <div className="d-flex align-items-center flex-nowrap position-sticky ml-auto mr-1">
                {role !== "console_user" && (
                  <GroupDropdown
                    items={headers}
                    attr={role === "store_admin" ? "store" : "brand"}
                    onSelectView={this.handleChangeSelectedBrand}
                    selectedView={selectedBrand}
                    hasRollup={role === "group_admin" || role === "accounting"}
                    className="mr-3 rounded-top text-nowrap"
                    style={{ zIndex: 100 }}
                  />
                )}

                <DateRangeDropdown
                  onDateRangeSelect={this.handleDateRangeClick}
                  statCardText={
                    this.handleDropdownText(
                      duration || this.props.duration,
                      date,
                      isCustomDate,
                    ) || "Today"
                  }
                  selectedDate={date}
                  startDate={date}
                  endDate={endDate}
                  selectedRange={duration}
                  className="rounded-top text-nowrap"
                  style={{ right: "0" }}
                />
              </div>
            </div>

            <div style={{ overflowX: "auto" }}>
              <ReportsTable
                data={orders}
                onClickSort={this.handleChangeSort}
                levelId={this.props.brand}
                webview={this.props.webview}
              />

              {totalResults > 0 && (
                <div className="position-sticky" style={{ left: 0 }}>
                  <PaginationBar
                    pagesArr={pagesArr}
                    totalResults={totalResults}
                    rows={orders.length}
                    pageNum={page}
                    limit={limit}
                    onSelectPage={this.handleSelectPage}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}
